// Which format a plan's body is written in (docs/architecture/clients.md,
// "Plans"): HTML when it begins as an HTML document does, Markdown otherwise.
// Nothing stores it but the body: the server's `format` says the same of the
// body it holds, and an edit in progress says its own.
import type { PlanFormat } from '../api/types'

/**
 * Past a byte-order mark and white space (HTML's: tab, line feed, form feed,
 * carriage return, space), `<!doctype html` in any case, followed by `>` or
 * white space.
 */
const HTML_BODY = /^\uFEFF?[\t\n\f\r ]*<!doctype html(?:>|[\t\n\f\r ])/i

/** Whether a body begins as an HTML document does. */
export function isHtmlBody(body: string): boolean {
  return HTML_BODY.test(body)
}

export function formatOf(body: string): PlanFormat {
  return isHtmlBody(body) ? 'html' : 'markdown'
}
